// src/App.tsx
import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header/Header';
import Content from './components/Content/Content';
import MaintenanceModal from './components/MaintenanceModal';
import config from './config';
import eolosLogo from '../src/assets/logo-eolos_dark.svg';

const App: React.FC = () => {
  const [measurementUnits, setMeasurementUnits] = useState('INT');
  const [theme, setTheme] = useState<'light' | 'dark'>('light');
  const websiteType = config.website;
  const isMaintenance = config.maintenance;

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  if (isMaintenance) {
    return (
      <MaintenanceModal
        isOpen={isMaintenance}
        logoSrc={eolosLogo}
        logoAlt="Eolos Logo"
      />
    );
  }

  return (
    <div className="App">
      <Header
        measurementUnits={measurementUnits}
        setMeasurementUnits={setMeasurementUnits}
        websiteType={websiteType}
        toggleTheme={() =>
          setTheme((prev) => (prev === 'light' ? 'dark' : 'light'))
        }
        theme={theme}
      />
      <Content
        measurementUnits={measurementUnits}
        theme={theme}
        website={websiteType}
      />
    </div>
  );
};

export default App;
